"use client";

import { useQuery } from "@tanstack/react-query";
import Header from "../../../components/admin/common/Header";
import PageWrapper from "../../../components/admin/common/PageWrapper";
import Sidebar from "../../../components/admin/common/Sidebar";
import EditForm from "../../../components/admin/members/EditForm";
import { useParams } from "react-router";
import { getMemberById } from "../../../services/memberServices";

const EditMember = () => {
  const memberId = useParams().id;

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["memberProfile", memberId],
    queryFn: () => getMemberById(memberId || undefined),
    enabled: !!memberId,
  });

  const { member = null, designations = [] } = data?.data || {};

  return (
    <div className="flex h-screen p-4 gap-4 bg-white overflow-hidden">
      <div className="h-full">
        <Sidebar />
      </div>

      <div className="flex-1 h-full bg-[#F3EFFF] rounded-[27px] overflow-hidden">
        <PageWrapper>
          <div className="flex flex-col h-full">
            <div className="flex-1 p-4 overflow-y-auto">
              <Header
                title="Edit Member"
                desc="Here you can edit member details."
              />

              <EditForm
                member={member}
                memberId={memberId}
                designation={designations}
              />
            </div>
          </div>
        </PageWrapper>
      </div>
    </div>
  );
};

export default EditMember;
